/* eslint-disable camelcase */
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import formatToCurrency from 'portuguese-utils/formaters/formatToCurrency'
import {
  SUPPORT_OPTIONS,
  BILLING_TYPE,
  CONTRACT_TYPE,
  PAYMENT_TYPE,
  ADDITIONAL_RESTRICTIONS,
} from './information-entries'

export const processIdentification = (
  { designation, description },
  {
    commercial_offer_website,
    website_standardized_contract_form,
    website_contract_conditions,
    contacts,
    email_contact,
    website_contact,
  }
) => ({
  designation,
  description,
  commercial_offer_website,
  website_standardized_contract_form,
  website_contract_conditions,
  contacts,
  email_contact,
  website_contact,
})

export const processComercial = (
  { additional_services },
  {
    contract_duration,
    offer_start_date,
    offer_validity,
    email_contract_contact,
    location_contract_contact,
    phone_contract_contact,
    electronic_billing,
    green_energy,
    paper_billing,
    direct_debit,
    atm_ctt,
    shop_payment,
    support_options,
    payment_periodicity,
    loyalty_clauses_description,
    has_additional_restrictions,
    additional_restrictions,
    offer_restrictions,
    price_function_of_access,
    price_revision_conditions,
    indexed_prices,
    website_contract_contact,
  }
) => {
  const newObj = {
    contract_duration,
    offer_start_date: offer_start_date
      ? moment(new Date(offer_start_date)).format('DD/MM/YYYY')
      : '',
    offer_validity: offer_validity
      ? moment(new Date(offer_validity)).format('DD/MM/YYYY')
      : '',
    contract_type: [
      email_contract_contact || website_contract_contact ? (
        email_contract_contact ? (
          <Link href={`mailto:${email_contract_contact}`} target='_blank'>
            {CONTRACT_TYPE.email_contract_contact}
          </Link>
        ) : (
          <Link href={website_contract_contact} target='_blank'>
            {CONTRACT_TYPE.email_contract_contact}
          </Link>
        )
      ) : (
        ''
      ),
      location_contract_contact ? (
        <Link href={`${location_contract_contact}`} target='_blank'>
          {CONTRACT_TYPE.location_contract_contact}
        </Link>
      ) : (
        ''
      ),
      phone_contract_contact ? (
        <Link href={`tel:${phone_contract_contact}`} target='_blank'>
          {CONTRACT_TYPE.phone_contract_contact} ({phone_contract_contact})
        </Link>
      ) : (
        ''
      ),
    ].filter((d) => d),
    billing_type: [
      electronic_billing ? BILLING_TYPE.electronic_billing : '',
      paper_billing ? BILLING_TYPE.paper_billing : '',
    ]
      .filter((d) => d)
      .join(', '),
    payment_type: [
      direct_debit ? PAYMENT_TYPE.direct_debit : '',
      atm_ctt ? PAYMENT_TYPE.atm_ctt : '',
      shop_payment ? PAYMENT_TYPE.shop_payment : '',
    ]
      .filter((d) => d)
      .join(', '),
    support_options:
      support_options &&
      support_options
        .map((so) => SUPPORT_OPTIONS.find((sup) => sup.slug === so).text)
        .join(', '),
    payment_periodicity,
    has_loyalty: !!additional_services.find((d) => d.id === 3),
    loyalty_clauses_description,
    green_energy,
    has_additional_restrictions,
    additional_restrictions:
      additional_restrictions &&
      additional_restrictions.map((d) => ADDITIONAL_RESTRICTIONS[d]),
    offer_restrictions,
    price_function_of_access,
    price_revision_conditions,
    indexed_prices,
  }

  if (!newObj.has_loyalty) {
    delete newObj.loyalty_clauses_description
  }

  if (!has_additional_restrictions) {
    delete newObj.additional_restrictions
  } else {
    delete newObj.has_additional_restrictions
  }

  if (!indexed_prices) {
    delete newObj.indexed_prices_description
  }

  return newObj
}

export const processAdditionalServices = (
  { additional_services },
  { additional_services_cost, optional_services_description }
) => {
  const newObj = {
    required_subscription_additional_services: !!additional_services.find(
      (d) => d.id === 5
    ),
    additional_services_cost: additional_services_cost
      ? `${formatToCurrency(additional_services_cost, 2)}`
      : '',
    optional_services_description,
  }

  return newObj
}

export const processRefunds = ({
  has_refunds,
  annual_refunds,
  refunds_description,
}) => {
  if (!has_refunds) {
    return { has_refunds }
  }
  const newObj = {
    has_refunds,
    annual_refunds: annual_refunds
      ? `${formatToCurrency(annual_refunds, 2)}`
      : '',
    refunds_description,
  }

  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === '' || newObj[key] === null) {
      delete newObj[key]
    }
  })

  return newObj
}

const Link = styled.a`
  word-wrap: 'break-word';
  color: #93c13e;
`



// WEBPACK FOOTER //
// ./src/components/DetailsModalV2/processor.js